module.exports = __webpack_public_path__ + "img/product.5b63fcec.png";